import { INonauthenticated, Nonauthenticated } from "./backend/nonauthenticated.generated.api";
import { IUsers, Users } from "./backend/users.generated.api";
import { IApiClient, create } from "./rest";
import { IReservations, Reservations } from "./backend/reservations.generated.api";
import { Admin, IAdmin } from "./backend/admin.generated.api";

export interface IBackendService {
    nonauthenticated(): INonauthenticated;
    users(): IUsers;
    reservations(): IReservations;
    admin(): IAdmin;
}

export class BackendService implements IBackendService {

    private rest_client: IApiClient;
    private internal_nonauthenticated: INonauthenticated;
    private internal_users: IUsers;
    private internal_reservations: IReservations;
    private internal_admin: IAdmin;

    constructor() {
        this.rest_client = create();
        this.internal_nonauthenticated = new Nonauthenticated(this.rest_client);
        this.internal_users = new Users(this.rest_client);
        this.internal_reservations = new Reservations(this.rest_client);
        this.internal_admin = new Admin(this.rest_client);
    }

    nonauthenticated(): INonauthenticated {
        return this.internal_nonauthenticated;
    }
    users(): IUsers {
        return this.internal_users;
    }
    reservations(): IReservations {
        return this.internal_reservations;
    }
    admin(): IAdmin {
        return this.internal_admin;
    }
}
